export enum NotificationButtonKind {
  Primary = 'btn-outline-primary',
  Secondary = 'btn-outline-secondary',
  Warning = 'btn-outline-warning',
  Error = 'btn-outline-danger',
  Success = 'btn-outline-success',
  Info = 'btn-outline-info'
}
